function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #e3f5fe !important;\n      }\n\n      .cls-1 {\n        opacity: 0.3;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        filter: url(#filter);\n      }\n\n      .cls-4 {\n        font-size: 16px;\n        fill: #083d77 !important;\n        color: black;\n        text-anchor: middle;\n        font-family: Montserrat;\n        font-weight: 400;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 0,
  y: 0,
  width: 84,
  height: 84,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  result: "offset",
  in: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "blur",
  stdDeviation: 4.583
}), /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodOpacity: 0.18
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupa_12",
  "data-name": "Grupa 12"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_2",
  "data-name": "Elipsa 1 kopia 2",
  className: "cls-1",
  cx: 83.25,
  cy: 88.125,
  r: 76.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_1_kopia_3",
  "data-name": "Elipsa 1 kopia 3",
  className: "cls-2",
  cx: 83.25,
  cy: 88.125,
  r: 55.844
}), /*#__PURE__*/React.createElement("image", {
  id: "pen-and-card",
  x: 55,
  y: 62,
  width: 56,
  height: 55,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA3CAYAAABZ0InLAAAE90lEQVRogdXaa4hWRRzH8a+6mUrWVmYXKyOCbmy+KZQlsZbNkrQiulAbUW8EIyrKsHu9KJQMigrDoigrqNQXirVdyKCicnsRsaIYRRH1ovCFbpdlbdli4DcxDHPOMzPnPD7HPzw85zLnPPN55pw5czmTpi1cRc0xD1gD7AQeAP6p+wdSoqvm880HPgSOBC4DzgSuAQ60l1Eck2s8l4uzsQzYBEyt8XeSoi6gj7sXGNKyQb4OTGmzJRh1AH3cbcBTwGIHeR2woRPIqsAe4H0P94KW93vIGzuBrAI0uO1At9ZdnI2DhZwOHBbakQu0uFlaD+FstAt5EvAc8Cvwt2rqnbr/p9tEOcAUnI26kYuEuV1QG+cCTwJfAXPIAObgbNSF7AMGgaO1PqhSewT4VtvOA7aay3ZK19wLY09cBWdjDNioTM7ROc8AtgD/RuK26RI0LaQbgAeBL4BPgZeA44ALgBOBX2JLsA6cjdyS9HGmhbRR+/qBe1TR3AH8aM8dA0zBTQJuVWbqRIZw5hI0MQB8oGevOc+40po4uxUwteQuB17RD3aXpCtCvpqB26C6ZAT4UtvH9T25DJhzWdq0XZEVmEFe5TTGbwJOz8SZP2u31i9Vmu+KMpF7z7mlNl6SzsYM4E2nMf4x8FMmbof2mdr0HC2/Heou+bi7W+AeUyl0ez2JkQicAVys9U+AK4AJDzeh+zqEGwWWOLj7gEe1vMfUqj7Qx90PPF2SSVOpPBy4HPdl4JaqReLjblYph3BL9YiwuNVa3gtcadK4wBBuTYuMHuXgTOvha11OW0uOmao+Yh247QW4PpXg/z36VNxpuiRnO9vWF9SCIdySNuOG7Q92ZeBWAmsD28ciccsCuIXtwKGDtiVelscHto37J07AmVjl9ACeqAuHSnCiBciPh5RB0+r4QyX3s7otOTi8Y+8E3lUvoQh3VwzOAi8BPgNOcA4qK0UDei/yz4jBrQCWO+vmUfMRMK0At8Kp2Utx6ATf60G5V9tWq/irRixunZNZ+wfPVMM5hHPTl+JwqvhhJa4LmYPr06PGbQGZR85fuTgTbn/wdw0gXasHcb8ux88PEm4usFklN6bb53CNyM1S5ZOE84F1IHNxJrPvqGIZVa/E7OsVsjcHFwJWQVbBodp8ttqd5phnhKMgfVQU9SZC9+TKBNyQlotw+wKZfRFYoBK0A8kTGjkzl+5FqThaTL5YpG3lrNUN7/csQrjFTuXg40Y0MRPK7HwP57ZosqJVp9QvyXXKbCvc/hKc23drK47IXncRsvE4EsZFQ8ihpuNIHPj1kfP03VgcGSPbPjKEW94UHJlT2MOqzk2P/C3gT2ffgFPLdhxHhTn6H/Rxo2yky43QhGlbcNQ4hV0Ft76mPASjDmAVXO78RnRUBTYaR0Vg43FUAB4SODKB10fiejR20zEcGcB+vdRjj9tV0CuwY63HaL0jOBKBJ+vB7r6usUDjqjOcbXXOBleOFODzwLFavkU9dtSischG4UgAnq/ZGhMvA69pOMJFbmkajgTggL4P6K0GNBzhIvubhiMB2KPvb4DfnO0G+ayXtjE4EoC2O3QqcISWZ+qtos1OukbhSOhNmJK7Wi/X7NJkf6+DHVWXZ1Mb85oVMcBFevfaxin62NihsczdjVE5EQN83JmYNPfbWZrd3aPR6MHI17A6EjHAN/T8M29TGNChE8B/TVj2KuKrnEcAAAAASUVORK5CYII="
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Elipsa_3",
  "data-name": "Elipsa 3",
  className: "cls-3",
  cx: 41.25,
  cy: 41.295,
  r: 21.25
});

var _ref5 = /*#__PURE__*/React.createElement("text", {
  id: "_1",
  "data-name": 1,
  className: "cls-4",
  x: 41,
  y: 46.501
}, "1");

var SvgKrok1 = function SvgKrok1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupa_28",
    "data-name": "Grupa 28",
    width: 159.75,
    height: 164.78,
    viewBox: "0 0 159.75 164.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKrok1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/krok1.fc77a817.svg";
export { ForwardRef as ReactComponent };